// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import Colors from 'components/styles/colors'
import { mediaMin } from 'frontend_core/dist/styles/media'
import { zIndexes, spacing } from 'frontend_core/dist/styles/variables'
import Close from 'components/atoms/Close'

const ModalBg = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.6);
  opacity: 0;
  z-index: ${zIndexes.topmost};
  visibility: hidden;
  transition: all 0.3s;
  ${({ isActive }) =>
    isActive &&
    css`
      opacity: 1;
      visibility: visible;
    `};
`

const ModalContainer = styled.div`
  width: 100%;
  height: 100%;
  overflow-y: auto;
`

const ModalContent = styled.div`
  padding: 0;
  ${mediaMin.phone`
    padding: ${spacing.huge_2}px 0;
  `};
`

const ModalInner = styled.div`
  padding: 0;
  ${mediaMin.phone`
    padding: 0 ${spacing.medium}px;
  `};
`

const ModalContentInner = styled.div`
  position: relative;
  width: 100%;
  max-width: 768px;
  min-height: 100vh;
  padding: ${spacing.large}px ${spacing.medium}px ${spacing.small_3}px;
  margin: 0 auto;
  background-color: ${Colors.white};
  ${mediaMin.phone`
    min-height: auto;
    padding: ${spacing.huge}px ${spacing.medium}px;
  `};
`

const ModalCloseContainer = styled.span`
  position: absolute;
  display: table;
  top: 16px;
  right: 16px;
  ${({ fixedCloseButton }) =>
    fixedCloseButton &&
    css`
      position: fixed;
      width: 32px;
      height: 32px;
      border-radius: 50%;
      background-color: ${Colors.white};
      box-shadow: 0 1px 3px rgba(0, 0, 0, 0.15);
      z-index: ${zIndexes.child};
      ${mediaMin.phone`
      position: absolute;
      width: auto;
      height: auto;
      border-radius: unset;
      background-color: unset;
      box-shadow: none;
    `};
    `};
`

const ModalCloseWrapper = styled.span`
  ${({ fixedCloseButton }) =>
    fixedCloseButton &&
    css`
      display: table-cell;
      vertical-align: middle;
      text-align: center;
      ${mediaMin.phone`
      display: inline-block;
    `};
    `};
`

const ChildrenWrapper = styled.div`
  width: 100%;
  max-width: 500px;
  margin: 0 auto;
  ${({ large }) =>
    large &&
    css`
      max-width: 600px;
    `};
`

export type PropTypes = {
  onClickClose: Function,
  isActive?: boolean,
  children?: ?any,
  large?: boolean,
  fixedCloseButton?: boolean,
}

export default (props: PropTypes) => (
  <ModalBg isActive={props.isActive}>
    <ModalContainer>
      <ModalInner>
        <ModalContent>
          <ModalContentInner>
            <ModalCloseContainer fixedCloseButton={props.fixedCloseButton}>
              <ModalCloseWrapper fixedCloseButton={props.fixedCloseButton}>
                <Close onClick={props.onClickClose} />
              </ModalCloseWrapper>
            </ModalCloseContainer>
            <ChildrenWrapper large={props.large}>
              {props.children}
            </ChildrenWrapper>
          </ModalContentInner>
        </ModalContent>
      </ModalInner>
    </ModalContainer>
  </ModalBg>
)



// WEBPACK FOOTER //
// ./src/components/molecules/ModalFullScreen/index.jsx